import React, { createContext, useContext, useEffect, useMemo } from 'react';

const STORAGE_KEY = 'digirasa_color_scheme';
const FIXED_SCHEME = 'maroon-orange';

export const COLOR_SCHEMES = [
  { value: 'original', label: 'Original' },
  { value: 'orange', label: 'Orange' },
  { value: 'maroon', label: 'Maroon' },
  { value: 'orange-maroon', label: 'Orange - Maroon' },
  { value: 'maroon-orange', label: 'Maroon - Orange' },
];

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute('data-color-scheme', FIXED_SCHEME);
    localStorage.setItem(STORAGE_KEY, FIXED_SCHEME);
  }, []);

  const value = useMemo(
    () => ({
      scheme: FIXED_SCHEME,
      setScheme: () => {},
      schemeOptions: COLOR_SCHEMES,
    }),
    [],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
